import React from 'react';
import {t} from '@lingui/core/macro';

import useDomainMonitorIncidents from 'features/domain/model/useDomainMonitorIncidents';
import LoaderCentered from 'shared/ui/LoaderCentered/LoaderCentered';
import TableBox from 'shared/ui/Box/TableBox/TableBox';
import PlugNoIncidents from 'shared/ui/Plugs/PlugNoIncidents/PlugNoIncidents';
import DomainIncidents from 'features/domain/ui/DomainIncident/DomainIncidents/DomainIncidents';
import {IDomainMonitorItem} from 'features/domain/model/DomainMonitor/IDomainMonitor';

import styles from './DomainMonitorIncidents.module.scss';

interface IDomainMonitorIncidentsProps {
    domainMonitor: IDomainMonitorItem,
}

const DomainMonitorIncidents: React.FC<IDomainMonitorIncidentsProps> = ({domainMonitor}) => {
    const {pagination, isLoading, isFetching, sort, setSort, setPage} = useDomainMonitorIncidents(domainMonitor.uuid);

    return (
        <TableBox className={styles.incidents}>
            <LoaderCentered active={isFetching}/>
            <div className={styles.titleBlock}>
                <h3 className={styles.title}>
                    <span>{t`Инциденты домена`}</span>
                    <span className={styles.name}>{domainMonitor.domain_human_readable}</span>
                </h3>
            </div>
            {
                pagination && <DomainIncidents
                    pagination={pagination}
                    isLoading={isLoading}
                    hideDomain
                    sort={sort}
                    setSort={setSort}
                    setPage={setPage}
                    plug={pagination.items.length === 0 && <PlugNoIncidents/>}
                />
            }
        </TableBox>
    );
};

export default DomainMonitorIncidents;
